import Page from 'modules/Page';
import makePage from 'modules/makePage';
import lazyWithSuspense from 'modules/lazyWithSuspense';
import * as parentConstants from 'modules/project-admin/ProjectDetailsPage/constants';
import { toTitleCase } from 'utils';
import { i18n } from 'i18n';
import * as constants from './constants';
import { EditProjectLicenceExpiryPageParams } from './constants';
import useEditProjectQueries, { EditProjectQueries } from './useEditProjectLicenceExpiryQueries';

const EditProjectLicenceExpiryPage = lazyWithSuspense(() => import('./EditProjectLicenceExpiryPage'));

const page: Page = {
  title: constants.TITLE,
  routeProps: {
    path: constants.ROUTE_PATH,
  },
  admin: true,
  component: makePage<EditProjectLicenceExpiryPageParams, EditProjectQueries>({
    WrappedPage: EditProjectLicenceExpiryPage,
    titleFn: ([project]) => (project.data ? i18n._('Edit').concat(` ${toTitleCase(project.data.name)}`).concat(i18n._('Licence Expiry')) : ''),
    parentPathTemplate: parentConstants.ROUTE_PATH,
    parentTitleFn: () => i18n._(parentConstants.TITLE),
    pageDataHook: useEditProjectQueries,
  }),
};

export default page;
